import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { PublicTenantRuntype } from './tenantBackendTypes';

export const tenantEndpoints = {
    'GET /tenant/details': endpoint({
        description: 'Public endpoint to get details of a tenant',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        responseBody: PublicTenantRuntype,
        requestBody: z.undefined(),
        base: 'public',
    }),
};
